module.exports = __webpack_public_path__ + "static/media/back2.1a61068b.png";